var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscountShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/discount-shape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "discount-shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M3.19858 8.59465C3.19782 8.59391 3.19705 8.59317 3.19629 8.59243L2.99293 8.80393L3.20039 8.59646L3.19858 8.59465ZM12.1744 8.59646L12.3818 8.80393L6.13234 2.55447L6.33981 2.76193L7.23175 1.86998C7.48098 1.62074 7.89376 1.62074 8.143 1.86998L9.03495 2.76194C9.14643 2.87341 9.29588 2.96102 9.43958 3.0206C9.58312 3.08012 9.74986 3.12365 9.9055 3.12365H11.1671C11.5215 3.12365 11.8126 3.4148 11.8126 3.76916V5.03077C11.8126 5.18642 11.8562 5.35316 11.9157 5.4967C11.9753 5.6404 12.0629 5.78986 12.1743 5.90133L13.0663 6.79329C13.3155 7.04253 13.3155 7.4553 13.0663 7.70454L12.1744 8.59646Z",
    fill: "#92ABFE",
    stroke: "#92ABFE",
    strokeWidth: 0.586806
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.45205 9.5906C9.12344 9.5906 8.85938 9.32654 8.85938 9.0038C8.85938 8.68105 9.12344 8.41699 9.44618 8.41699C9.76892 8.41699 10.033 8.68105 10.033 9.0038C10.033 9.32654 9.7748 9.5906 9.45205 9.5906Z",
    fill: "#92ABFE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.93643 6.06961C5.60782 6.06961 5.34375 5.80554 5.34375 5.4828C5.34375 5.16006 5.60781 4.896 5.93056 4.896C6.2533 4.896 6.51736 5.16006 6.51736 5.4828C6.51736 5.80554 6.25917 6.06961 5.93643 6.06961Z",
    fill: "#92ABFE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.92301 9.44354C5.81152 9.44354 5.70003 9.40248 5.61201 9.31446C5.44183 9.14428 5.44183 8.86258 5.61201 8.69241L9.13284 5.17158C9.30301 5.0014 9.58468 5.0014 9.75485 5.17158C9.92502 5.34175 9.92502 5.62345 9.75485 5.79362L6.23402 9.31446C6.146 9.40248 6.0345 9.44354 5.92301 9.44354Z",
    fill: "#92ABFE"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountShape);
export default __webpack_public_path__ + "static/media/discount-shape.c1e4ea104066f4877132eeccf8853d04.svg";
export { ForwardRef as ReactComponent };